import { ColumnType } from '@placer-ui/components/dist/data-grid/data-grid-types';
import { PersonalTagTableRow } from 'features/my-zone/tags/tag-page/types/types';

export const DEFAULT_EMPTY_VALUE = '--';

export const LOADABLE_METRICS_COLUMNS: ColumnType<PersonalTagTableRow>[] = [
    {
        field: 'name',
        headerName: '',
        flex: 1,
    },
    {
        field: 'name',
        headerName: '',
        flex: 1,
    },
    {
        field: 'name',
        headerName: '',
        flex: 1,
    },
];
